export default "/_next/static/images/ad2-d1809c6e611af3350f537415f8f53248.png";